import type { Person, StaffingStatus } from "../services/api";

interface PeopleTableProps {
  people: Person[];
  onEdit: (person: Person) => void;
  onDelete: (person: Person) => void;
  onSelectSkills: (person: Person) => void;
}

function getStatusBadgeClass(status?: StaffingStatus): string {
  switch (status) {
    case "POOL":
    case "BEACH":
      return "status-badge status-available";
    case "ASSIGNED":
      return "status-badge status-assigned";
    case "HELD":
      return "status-badge status-held";
    default:
      return "status-badge";
  }
}

export function PeopleTable({ people, onEdit, onDelete, onSelectSkills }: PeopleTableProps) {
  return (
    <div className="panel">
      <h2>People</h2>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Region</th>
              <th>Status</th>
              <th>Specialty</th>
              <th>Role</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {people.length === 0 && (
              <tr>
                <td colSpan={7} className="empty">
                  No people found. Add a new consultant to get started.
                </td>
              </tr>
            )}
            {people.map((person) => (
              <tr key={person.email}>
                <td>{person.name}</td>
                <td>{person.email}</td>
                <td>{person.region ?? "-"}</td>
                <td>
                  {person.status ? (
                    <span className={getStatusBadgeClass(person.status as StaffingStatus)}>
                      {person.status}
                    </span>
                  ) : (
                    "-"
                  )}
                </td>
                <td>{person.speciality ?? "-"}</td>
                <td>{person.coe_level ?? "-"}</td>
                <td className="actions">
                  <button type="button" onClick={() => onEdit(person)}>
                    Edit
                  </button>
                  <button type="button" onClick={() => onSelectSkills(person)}>
                    Assign Skills
                  </button>
                  <button type="button" className="danger" onClick={() => onDelete(person)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
